import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Agreements from "./pages/Agreements";
import DriverA from "./pages/DriverA";
import DriverB from "./pages/DriverB";

/**
 * ルーティング
 *   /driver             → LP-A（こだわり条件なし）
 *   /drivers            → LP-B（こだわり条件あり）
 *   /driver/agreements  → 利用規約・個人情報の取扱い・提携会社一覧
 * ABテストは広告側でURLを出し分ける運用です。どちらの経由かは
 * Firestore の variant フィールドと GA4 のイベントで判別できます。
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/driver" element={<DriverA />} />
        <Route path="/drivers" element={<DriverB />} />
        <Route path="/driver/agreements" element={<Agreements />} />
        <Route path="*" element={<Navigate to="/driver" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
